<template>
  <div>
    <div class="card">
      <div class="card-header border-bottom">
        <div></div>
        <div class="card-toolbar">
          <div class="d-flex align-items-center gap-2 gap-lg-3">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" class="btn-icon"
              :to="{ name: 'bPendalamanRegister' }">
              <feather-icon icon="CornerUpLeftIcon" />
            </b-button>
          </div>
        </div>
      </div>
      <div class="card-body pt-1">
        <validation-observer ref="simpleRules">
          <div id="knowledge-base-search">
            <b-card no-body class="knowledge-base-bg text-center bg-light-primary">
              <b-card-body class="card-body">
                <h2 class="text-primary text-uppercase">
                  Pendalaman Register
                </h2>
                <b-card-text class="mb-2">
                  {{ kolok }}
                  <span class="font-weight-bold">Pilih register BMD yang akan dilakukan pendalaman register </span>
                </b-card-text>
                <div class="row d-flex justify-content-center">
                  <ModalLookupRegisterBdm :model-value="modalData" @dialogConfirm="confirmLookupRegisterBmdDialog"
                    @closeDialog="closeLookupRegisterBmdDialog" />
                </div>
              </b-card-body>
            </b-card>
          </div>
        </validation-observer>
        <div ref="formDataRegisterRef">
          <div class="border border-1 rounded p-1 mx-25 mb-2" style="min-height: 50vh;">
            <div class="text-center mb-1">
              <h4 class="font-weight-bolder text-muted text-uppercase">Data Register BMD</h4>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Guid ID</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.guid_aset || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Register</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.noreg_108 || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Kode Barang</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.kobar_108 || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nama Barang</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nabar_108 || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Tanggal Perolehan</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ parserValue('dateOnly', formDatas.data_register.tgl_oleh) || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Total Harga</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ Intl.NumberFormat('id-ID', {
                  maximumFractionDigits: 2,
                }).format(formDatas.data_register.harga_oleh || 0) }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Bahan</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.bahan || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Merk</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.merk || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Tipe</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.tipe || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Chasis</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nochasis || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Mesin</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nomesin || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor Polisi</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nopol || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <span class="col-lg-3 col-md-3 font-weight-normal font-small-5">Nomor BPKB</span>
              <div class="col-lg-9 col-md-9 font-weight-bold">
                {{ formDatas.data_register.nobpkb || '-' }}
              </div>
            </div>
          </div>
        </div>
        <template v-if="Object.keys(formDatas.data_register).length > 0">
          <div class="row mx-0">
            <div class="col-12">
              <span class="text-muted text-uppercase font-medium-1 font-weight-bold">Form Pendalaman Register </span>
            </div>
          </div>
          <div class="p-1 mx-25 mb-2" style="min-height: 10vh;">
            <validation-observer ref="simpleRules">
              <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Permasalahan BMD <span
                    class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                  <validation-provider #default="{ errors }" name="Permasalahan BMD" rules="required">
                    <div class="d-flex flex-row mt-50 mt-md-0" style="gap:10px">
                      <b-form-radio v-model="formDatas.jenis_pendalaman" value="biaya-biaya">
                        Merupakan Biaya Biaya
                      </b-form-radio>
                      <b-form-radio v-model="formDatas.jenis_pendalaman" value="fisik-tidak-ditemukan">
                        Fisik Tidak Ditemukan
                      </b-form-radio>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
              <div>
                <div v-if="formDatas.jenis_pendalaman == 'biaya-biaya'">
                  <FormDatasA :fD="formDatas.biaya_biaya" :bmd="formDatas.data_register" />
                </div>
                <div v-else-if="formDatas.jenis_pendalaman == 'fisik-tidak-ditemukan'">
                  <FormDatasB :fD="formDatas.fisik_tidak_ditemukan" :bmd="formDatas.data_register" />
                </div>
              </div>
            </validation-observer>
          </div>
        </template>
      </div>
      <div class="card-footer d-flex justify-content-end pe-5 ps-5 gap-2">
        <template v-if="Object.keys(formDatas.data_register).length > 0">
          <b-button v-if="!loadingBtnSubmit" variant="primary" @click="submitForm">
            <feather-icon icon="EditIcon" class="mr-50" />
            <span class="align-middle">Kirim</span>
          </b-button>
          <b-button v-else variant="primary" disabled class="mr-1">
            <b-spinner small />
            Loading...
          </b-button>
        </template>

      </div>
    </div>

  </div>
</template>

<script>

import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate';

import { required } from '@validations'
import pendalamanRegister from "@/composables/b/pendalamanRegister";
import { id as localeId } from "vee-validate/dist/locale/id";
import { showNotifikasi } from '@/libs/helper';
import ModalLookupRegisterBdm from './components/ModalLookupRegisterBdm';
import FormDatasA from './components/FormDatasA.vue'
import FormDatasB from './components/FormDatasB.vue'
import { parserValue } from '@/libs/helper'

export default {
  setup(props, context) {
    const g = context.root;
    const tahun = ref(g.$route.query.tahun || g.$cookies.get("tahun") || moment().format('YYYY'));
    const kolok = ref(g.$route.query.kolok || g.$cookies.get("kolok") || null);
    /* IMPPORTANT FORM DATA HARUS DI DEFINE DULU */
    const formDatas = ref({
      jenis_pendalaman: null,
      data_register: {},
      biaya_biaya: {
        biaya_beban: null,
        is_aset_induk: null,
        jenis_beban: null,
        kolok_aset_induk: null,
        kib_aset_induk: null,
        kobar_aset_induk: null,
        noreg_aset_induk: null,
        kronologis_biaya_beban: null
      },
      fisik_tidak_ditemukan: {
        sebab_tidak_ditemukan: null,
        is_ada_dokumen_pendukung: null,
        dokumen_pendukung_berupa: null,
        file_dokumen_sk: null,
        kronologis: null
      }
    });
    const modalData = ref({
      show: false,
      data: null,
    });
    const formDataRegisterRef = ref(null);
    const confirmLookupRegisterBmdDialog = (data) => {
      modalData.value.show = false;
      formDatas.value.tahun = tahun;
      formDatas.value.kolok = data.kolok;
      formDatas.value.data_register = { register_b_detail_id: data.id, ...data };
      delete formDatas.value.data_register.id;
      formDataRegisterRef.value.scrollIntoView({ behavior: 'smooth' });

    };
    const closeLookupRegisterBmdDialog = (item) => {
      modalData.value.show = false;
    };

    /* FORM */
    const loadingBtnSubmit = ref(false);
    const submitForm = () => {
      let payload = formDatas.value;
      payload.username = g.$cookies.get('username');
      context.refs.simpleRules.validate().then(async success => {
        if (success) {
          loadingBtnSubmit.value = true;
          pendalamanRegister.submitPengajuan(g, payload).then(resp => {
            if (resp.success) {
              showNotifikasi(g, 'success', 'Success', resp.message)
              g.$router.push({ name: 'bPendalamanRegister' })
            } else {
              showNotifikasi(g, 'danger', 'Error', resp.message)
            }
            loadingBtnSubmit.value = false;
          }).catch(err => {
            console.log(err)
            loadingBtnSubmit.value = false;
          })
        }
      });
    };

    return {
      kolok,
      parserValue,
      formDataRegisterRef,
      formDatas,
      closeLookupRegisterBmdDialog,
      confirmLookupRegisterBmdDialog,
      modalData,

      submitForm,
      loadingBtnSubmit,
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ModalLookupRegisterBdm,
    FormDatasA,
    FormDatasB
  },
  data() {
    return {
      required,
    }
  },
  directives: {
    Ripple,
  },
  props: {
    page: String,
  },
};
</script>
